module.exports = __webpack_public_path__ + "static/media/cut.54f9df7f.svg";